import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoadingLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#paint0_angular_136_18352_clip_path)",
			"data-figma-skip-parse": "true",
			children: /* @__PURE__ */ _jsx("g", {
				transform: "matrix(0.0036423 -0.00997236 0.01 0.00335374 12 12.027)",
				children: /* @__PURE__ */ _jsx("foreignObject", {
					x: -1336.98,
					y: -1336.98,
					width: 2673.97,
					height: 2673.97,
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							background: "conic-gradient(from 90deg,rgba(0, 0, 0, 0) 0deg,rgba(0, 0, 0, 1) 360deg)",
							height: "100%",
							width: "100%",
							opacity: 1
						}
					})
				})
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.8856 2.06088C11.4345 1.99995 11.9289 2.39554 11.9898 2.94445C12.0508 3.49337 11.6552 3.98774 11.1063 4.04867C7.07901 4.4957 4 7.91355 4 11.9994C4 16.4177 7.58172 19.9994 12 19.9994V21.9994C6.47715 21.9994 2 17.5222 2 11.9994C2 6.89163 5.8481 2.62005 10.8856 2.06088Z",
			"data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":0.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":7.2846012115478516,\"m01\":20.0,\"m02\":-1.6423014402389526,\"m10\":-19.944711685180664,\"m11\":6.7074885368347168,\"m12\":18.645656585693359},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"stopsVar\":[],\"visible\":true}"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#paint1_angular_136_18352_clip_path)",
			"data-figma-skip-parse": "true",
			children: /* @__PURE__ */ _jsx("g", {
				transform: "matrix(0.0036423 -0.00997236 0.01 0.00335374 12 12.027)",
				children: /* @__PURE__ */ _jsx("foreignObject", {
					x: -1336.98,
					y: -1336.98,
					width: 2673.97,
					height: 2673.97,
					children: /* @__PURE__ */ _jsx("div", {
						xmlns: "http://www.w3.org/1999/xhtml",
						style: {
							background: "conic-gradient(from 90deg,rgba(0, 0, 0, 0) 0deg,rgba(0, 0, 0, 1) 360deg)",
							height: "100%",
							width: "100%",
							opacity: 1
						}
					})
				})
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.322 4.04011C16.6379 3.58711 17.2613 3.47598 17.7143 3.79191C20.3784 5.6499 22 8.68893 22 11.9994C22 17.5222 17.5228 21.9994 12 21.9994V19.9994C16.4183 19.9994 20 16.4177 20 11.9994C20 9.34981 18.7036 6.92021 16.5702 5.43237C16.1172 5.11645 16.0061 4.49311 16.322 4.04011Z",
			"data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":0.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":7.2846012115478516,\"m01\":20.0,\"m02\":-1.6423014402389526,\"m10\":-19.944711685180664,\"m11\":6.7074885368347168,\"m12\":18.645656585693359},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"stopsVar\":[],\"visible\":true}"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
			id: "paint0_angular_136_18352_clip_path",
			children: /* @__PURE__ */ _jsx("path", { d: "M10.8856 2.06088C11.4345 1.99995 11.9289 2.39554 11.9898 2.94445C12.0508 3.49337 11.6552 3.98774 11.1063 4.04867C7.07901 4.4957 4 7.91355 4 11.9994C4 16.4177 7.58172 19.9994 12 19.9994V21.9994C6.47715 21.9994 2 17.5222 2 11.9994C2 6.89163 5.8481 2.62005 10.8856 2.06088Z" })
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "paint1_angular_136_18352_clip_path",
			children: /* @__PURE__ */ _jsx("path", { d: "M16.322 4.04011C16.6379 3.58711 17.2613 3.47598 17.7143 3.79191C20.3784 5.6499 22 8.68893 22 11.9994C22 17.5222 17.5228 21.9994 12 21.9994V19.9994C16.4183 19.9994 20 16.4177 20 11.9994C20 9.34981 18.7036 6.92021 16.5702 5.43237C16.1172 5.11645 16.0061 4.49311 16.322 4.04011Z" })
		})] })
	]
});
export default SvgLoadingLine;
